import { ClarityType } from '../constants';

function listCV(values) {
  return {
    type: ClarityType.List,
    list: values
  };
}

export { listCV };